export default "__VITE_ASSET__CsQ$SvC0__"